module.exports = {
    API_URL: process.env.REACT_APP_BACKEND_API_URL,
    AWS_PROFILE_FOLDER: "profile",
    GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    AWS_TEMP_URL_VALIDITY_HOUR:24,
    AWS_ACCESS_KEY_ID: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    AWS_REGION: process.env.REACT_APP_AWS_REGION,
    AWS_BUCKET: process.env.REACT_APP_AWS_BUCKET,
    CRYPTO_SECRET_KEY: "ztohxhkzvgxzjxgyzzmg",
    DEVICE_TYPE: "W",
    DEFAULT_COUNTRY_CODE: "91",
    DEFAULT_CURRENCY: "AED",
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    FIREBASE_VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    // API_METHOD_LIST: [
    //   { slug: 'GET', name: "GET" },
    //   { slug: 'POST', name: "POST" }
    // ],
    // API_CODE_LIST: [
    //   { id: 200, name: 200 },
    //   { id: 400, name: 400 },
    //   { id: 401, name: 401 },
    //   { id: 404, name: 404 },
    // ],
    // API_STATUS_LIST: [
    //   { slug: "success", name: "Success" },
    //   { slug: "fail", name: "Fail" }
    // ],
  };